import axios from "axios";
import {
    GET_ERRORS,
    TRELLO_ADD,
    USER_UPDATE
} from "./types";
import { toast } from "react-toastify";

export const addUser = (userData, getData, hideModal) => dispatch => {
    axios
        .post("/api/user-add", userData)
        .then(res => {
            hideModal()
            toast.success("User added");
            getData()
        }
        ).catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const addTrello = (userData, getData, hideModal) => dispatch => {
    
    axios.post("/api/add-trello", userData).then((res)=> {
        hideModal()
        
        dispatch({
            type: TRELLO_ADD,
            payload: res,
        })
    }).catch((err)=> {
        console.log("ERR: ", err)
    })
};
export const addListInBoard = (selectedLists, board, hideModal) => dispatch => {
    axios.post("/api/add-list-in-boards", {list: selectedLists, boardId: board}).then((res)=> {
        hideModal()
    }).catch((err)=> {
        console.log("ERR: ", err)
    })
};

export const updateUser = (userData, getData, hideModal, shouldDispatch) => dispatch => {
    axios
        .post("/api/user-update", userData)
        .then(res => {
            hideModal()
            toast.success("User updated");
            getData()

            if (shouldDispatch) {
                dispatch({
                    type: USER_UPDATE,
                    payload: res,
                })
            }
        }).catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};
